import 'css-chunksrc/client/pages/planzoneParametersPage/calendarsHolidays/styles.scss';export default {
  "container": "_container_1ykpy_1",
  "blockHead": "_blockHead_1ykpy_5",
  "label": "_label_1ykpy_12",
  "hint": "_hint_1ykpy_18",
  "count": "_count_1ykpy_24",
  "list": "_list_1ykpy_34",
  "empty": "_empty_1ykpy_40",
  "emptyIcon": "_emptyIcon_1ykpy_53",
  "addButton": "_addButton_1ykpy_60",
  "addPlus": "_addPlus_1ykpy_86"
};